import { Fragment } from 'react';

import useExpandedRow from '@usas/ui-web/components/grids/UseExpandedRow';

import AthleteUserPurchasesLargeGrid from './AthleteUserPurchasesLargeGrid';
import AthleteUserPurchasesSmallGrid from './AthleteUserPurchasesSmallGrid';

const AthleteUserPurchasesGrid = ({ gridData, isLoading, onDeletePurchaseItemDetailClicked }) => {
  const { onClick, expandedId } = useExpandedRow();
  return (
    <Fragment>
      <AthleteUserPurchasesLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onClick={onClick}
        expandedId={expandedId}
        onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
      />
      <AthleteUserPurchasesSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onClick={onClick}
        expandedId={expandedId}
        onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
      />
    </Fragment>
  )
};

export default AthleteUserPurchasesGrid;